import React, { useState, useEffect } from "react";
import { api } from "../../services/api.js";
import { Button, Form, Spinner, Container, Card, Row, Col } from "react-bootstrap";
import Swal from "sweetalert2";
import Menu from "../../comum/Menu/menu.jsx";
import Footer from "../../comum/Footer/index.jsx";
import "./AssociarLoja.css";
import Foto from "../Components/Foto";

export default function AssociarLoja() {
  const [matricula, setMatricula] = useState("");
  const [dados, setDados] = useState(null);
  const [foto, setFoto] = useState(
    "https://upload.wikimedia.org/wikipedia/commons/0/03/Sem_imagem.jpg"
  );
  const [lojas, setLojas] = useState([]);
  const [lojaSelecionada, setLojaSelecionada] = useState("");
  const [loading, setLoading] = useState(false);
  const [fotoSelecionada, setFotoSelecionada] = useState(null);

  const abrirFoto = () => {
    if (!foto) return;

    setFotoSelecionada({
      foto: foto,
      nome: dados?.nome,
      loja: dados?.secao,
    });
  };

  // Carrega lista de lojas
  useEffect(() => {
    api
      .get("/lojas/localizacao")
      .then((ret) => setLojas(ret.data))
      .catch((err) => console.error("Erro ao carregar lojas:", err));
  }, []);

  const buscarFuncionario = async () => {
    if (!matricula) {
      Swal.fire("Atenção", "Informe a matrícula do funcionário!", "warning");
      return;
    }

    setLoading(true);
    setDados(null);
    setFoto("https://upload.wikimedia.org/wikipedia/commons/0/03/Sem_imagem.jpg");

    try {
      const res = await api.get(`/usuario/dados/${matricula}`);
      if (!res.data || res.data.length === 0) {
        Swal.fire("Ops!", "Funcionário não encontrado!", "info");
        setLoading(false);
        return;
      }
      setDados(res.data[0]);
      buscarFoto(matricula);
    } catch (err) {
      Swal.fire("Erro", "Erro ao buscar dados do funcionário", "error");
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  const buscarFoto = async (matricula) => {
    try {
      const res = await api.get(`/usuario/foto/${matricula}`);
      if (res.data?.foto)
        setFoto("data:image/jpeg;base64," + res.data.foto);
    } catch {
      setFoto("https://upload.wikimedia.org/wikipedia/commons/0/03/Sem_imagem.jpg");
    }
  };

  const associarLoja = async () => {
    if (!dados) {
      Swal.fire("Atenção", "Busque um funcionário primeiro!", "warning");
      return;
    }
    if (!lojaSelecionada) {
      Swal.fire("Atenção", "Selecione uma loja!", "warning");
      return;
    }

    try {
      await api.post("/usuarios/erps", {
        matricula,
        loja: lojaSelecionada,
      });

      Swal.fire({
        icon: "success",
        title: "Sucesso!",
        text: `Usuário alterado com sucesso para a filial ${lojaSelecionada}. Aguarde aproximadamente 5 minutos para que a atualização seja refletida.`,
        confirmButtonColor: "#8b0000",
      });

      setLojaSelecionada("");
      setMatricula("");
      setDados(null);
      setFoto("https://upload.wikimedia.org/wikipedia/commons/0/03/Sem_imagem.jpg");
    } catch (err) {
      console.error(err);
      Swal.fire("Erro", "Não foi possível associar a loja!", "error");
    }
  };

  return (
    <div style={{ display: 'flex', flexDirection: 'column', minHeight: '100vh', backgroundColor: '#f8f9fa' }}>
      <Menu modulo="ARBOR" />
      
      <Container fluid className="px-4 mt-4 pt-4 mb-5" style={{ flex: 1, maxWidth: '900px' }}>
        <div className="d-flex justify-content-between align-items-center mb-4">
          <h4 className="fw-bold text-dark m-0">
            <i className="fa-solid fa-link text-danger me-2"></i>Associação de Funcionário à Loja
          </h4>
        </div>

        <Card className="shadow-sm border-0 bg-white rounded-3 p-4 mb-4">
          {/* Campo de matrícula e botão de busca */}
          <Row className="g-3 align-items-end mb-3">
            <Col md={8} xs={12}>
              <Form.Label className="small fw-bold text-muted">MATRÍCULA DO FUNCIONÁRIO</Form.Label>
              <Form.Control
                type="text"
                className="rounded-2"
                value={matricula}
                onChange={(e) => setMatricula(e.target.value)}
                placeholder="Digite a matrícula (ex: 12345)"
                onKeyDown={(e) => e.key === 'Enter' && buscarFuncionario()}
              />
            </Col>
            <Col md={4} xs={12}>
              <Button
                variant="danger"
                className="btn-arbor-primary w-100 fw-bold py-2 rounded-2"
                onClick={buscarFuncionario}
                disabled={loading}
              >
                {loading ? (
                  <Spinner size="sm" animation="border" />
                ) : (
                  <>
                    <i className="fa-solid fa-magnifying-glass me-2"></i>Buscar
                  </>
                )}
              </Button>
            </Col>
          </Row>

          {dados && (
            <div className="border-top pt-4 mt-3">
              <div className="text-center mb-4">
                <img
                  src={foto}
                  alt="Foto do funcionário"
                  className="rounded-circle shadow-sm border"
                  style={{
                    width: 120,
                    height: 120,
                    objectFit: "cover",
                    cursor: "pointer",
                    border: '3px solid #8b0000'
                  }}
                  onClick={abrirFoto}
                />
                <div className="small text-muted mt-1">Clique para ampliar</div>
              </div>

              <Row className="g-3">
                <Col md={6} xs={12}>
                  <Form.Label className="small fw-bold">Nome</Form.Label>
                  <Form.Control
                    type="text"
                    className="bg-light fw-bold"
                    value={dados.nome}
                    disabled
                  />
                </Col>
                <Col md={3} xs={12}>
                  <Form.Label className="small fw-bold">Seção</Form.Label>
                  <Form.Control
                    type="text"
                    className="bg-light"
                    value={dados.secao}
                    disabled
                  />
                </Col>
                <Col md={3} xs={12}>
                  <Form.Label className="small fw-bold">Função</Form.Label>
                  <Form.Control
                    type="text"
                    className="bg-light"
                    value={dados.funcao}
                    disabled
                  />
                </Col>
              </Row>

              <Row className="g-3 mt-3 align-items-end border-top pt-3">
                <Col md={8} xs={12}>
                  <Form.Label className="small fw-bold text-dark">
                    <i className="fa-solid fa-store me-1 text-danger"></i>Selecione a Nova Loja
                  </Form.Label>
                  <Form.Select
                    value={lojaSelecionada}
                    onChange={(e) => setLojaSelecionada(e.target.value)}
                    className="fw-bold"
                  >
                    <option value="">-- Escolha a Loja --</option>
                    {lojas.map((l, idx) => (
                      <option key={idx} value={l.cod_emp}>
                        Loja {String(l.cod_emp).padStart(2, '0')} - {l.razao}
                      </option>
                    ))}
                  </Form.Select>
                </Col>
                <Col md={4} xs={12}>
                  <Button
                    variant="danger"
                    className="btn-arbor-primary w-100 fw-bold py-2 rounded-2"
                    onClick={associarLoja}
                  >
                    <i className="fa-solid fa-check me-2"></i>Associar
                  </Button>
                </Col>
              </Row>
            </div>
          )}
        </Card>
      </Container>

      <Footer />

      <Foto
        show={!!fotoSelecionada}
        onClose={() => setFotoSelecionada(null)}
        foto={fotoSelecionada?.foto}
        nome={fotoSelecionada?.nome}
        info01={fotoSelecionada?.loja}
        info02=""
      />
    </div>
  );
}